module.exports = __webpack_public_path__ + "static/media/empty.9e1e8995.svg";